import { DocumentType } from "generated-graphql/graphql";

/**
 * Whether a review request from the documents catalog should open the manifest
 * review screen rather than the generic metadata form.
 *
 * The catalog's Edit opens one dialog for every document type, which on a
 * manifest means editing the file's title and tags instead of the data read off
 * the form. For most manifests that is merely the wrong screen — Shipment
 * Documents has a row that opens the right one. For a manifest whose generator
 * EPA ID matched no facility it is the whole story: the catalog is the only
 * place that lists it, so the wrong dialog made it unreviewable.
 *
 * Mixed selections keep the generic form. A batch spanning types has no single
 * right screen, and silently reviewing only the manifests in it would be a
 * worse surprise than the form the user asked for.
 */
export function shouldOpenManifestReview({
  documentTypes,
  wasteModuleEnabled,
}: {
  /** The type of each document in the review request, in any order. */
  documentTypes: (DocumentType | null | undefined)[];
  /** The tenant's stored waste-module value — manifest data only exists where the backend ingests it. */
  wasteModuleEnabled: boolean;
}): boolean {
  if (!wasteModuleEnabled) return false;
  if (documentTypes.length === 0) return false;
  return documentTypes.every((documentType) => documentType === DocumentType.RcraManifest);
}
